// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"N6-z"};